<template>
    <div>
        <b-modal :active="locationEditorOpen" @close="onCancelLocationEditor()">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <alert-container :messages="msgs" />
            <div class="modal-card modal-default">
                <section class="modal-card-body">
                    <div class="columns is-flex-wrap">
                        <div class="column is-8">
                            <h1 class="title">{{ $t('localizacao') }}</h1>
                            <span v-if="showSaveButton">
                                <h3 v-if="center.lat == null || center.lat == 0">
                                    {{ $t('msg-cadastro-coordenadas') }}
                                </h3>
                                <h3 v-else>{{ $t('msg-edicao-coordenadas') }}</h3>
                                <h3
                                    v-if="critica"
                                    class="is-text-color-danger mt-2"
                                    v-html="
                                        $t('msg-info-maps-critica', 
                                            { n: `<a href='${linkGerenciarUsuarios}' style='color: black;' class='is-bold'>` +
                                                    $t('gerenciar-usuarios') + '</a>' }
                                        )
                                    "
                                />
                            </span>
                        </div>
                        <div class="column is-4 buttons-maps">
                            <button
                                class="delete-btn"
                                type="button"
                                @click="onCancelLocationEditor()"
                            >
                                {{ $t('cancelar') }}
                            </button>
                            <button
                                class="save-btn"
                                type="button"
                                @click="updateLocation()"
                                :disabled="isUpdating"
                                v-if="showSaveButton"
                            >
                                {{ $t(label) }}
                                <button-loader :isSaving="isUpdating" />
                            </button>
                        </div>
                        <div class="column is-12">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                                :placeholder="$t('endereco')"
                                :startSearchWith="startSearchWith"
                                v-if="showSaveButton"
                                disableTitle
                            />
                        </div>
                    </div>
                    <div class="location">
                        <GoogleMaps
                            ref="gmap"
                            :center="center"
                            :geocoded="true"
                            :startmarker="true"
                            :zoom="zoom"
                            :options="mapOptions"
                            :clickMoveMarker="showSaveButton"
                            :clickable="showSaveButton"
                        />
                        <br clear="all" />
                    </div>
                </section>
            </div>
        </b-modal>
    </div>
</template>

<script>
import GoogleMaps from '@/components/shared/maps/MapasGoogleMaps.vue';
import Message from '@/models/Message';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    name: 'MapasGoogleMapsModal',

    components: {
        GoogleMaps,
        ContainerLoader,
    },
    props: {
        critica: {
            default: false,
            type: Boolean,
        },
        update: {
            default: false,
            type: Boolean,
        },
        center: {
            default: () => {
                return {
                    lat: 0,
                    lng: 0,
                };
            },
        },
        isLoading: {
            default: false,
            type: Boolean,
        },
        locationEditorOpen: {
            default: false,
            type: Boolean,
        },
        isUpdating: {
            default: false,
            type: Boolean,
        },
        label: {
            default: 'salvar',
            type: String,
        },
        startSearchWith: {
            default: '',
            type: String,
        },
        showSaveButton: {
            default: true,
            type: Boolean,
        },
    },
    data() {
        return {
            debouncedOnSearch: null,
            mapOptions: { gestureHandling: 'cooperative' },
            msgs: [],
            zoom: 13,
            linkGerenciarUsuarios: this.getHrefRoute(this.$router, 'usuario-gerenciar-list'),
            validateAddress: [
                'postal_code',
                'administrative_area_level_1',
                'administrative_area_level_2',
                'route',
            ],
        };
    },
    created() {
        this.debouncedOnSearch = this.debounce(this.getLocation, 1000);
    },
    watch: {
        locationEditorOpen(val) {
            this.zoom = this.center.lat == null || this.center.lat == 0 ? 4 : 13;
            if (val && this.update) this.verifyLocationIsValid();
        },
    },
    methods: {
        verifyLocationIsValid() {
            if (
                !(this.center.lat >= -90 && this.center.lat <= 90 && this.center.lat != 0.0) ||
                !(this.center.lng >= -180 && this.center.lng <= 180 && this.center.lng != 0.0)
            ) {
                this.msgs.push(new Message('alert', 'localizacao-inicial-nao-encontrada', true));
            }
        },
        updateLocation() {
            this.getLocationValid();
        },
        getLocation(address) {
            address = this.mapTosave(address);
            let mapa = this.$refs.gmap;
            mapa.codeAddress(address, (results, status) => {
                if (status == 'OK') {
                    let latlong = results[0].geometry.location;
                    this.center.lat = latlong.lat();
                    this.center.lng = latlong.lng();
                    this.zoom = 13;
                    mapa.loadSingleMarker();
                } else {
                    if (status == 'REQUEST_DENIED') {
                        this.msgs.push(new Message('alert', 'msg-geocode-activate', true));
                    } else {
                        if (address != null && address != '') {
                            this.msgs.push(new Message('alert', 'busca-sem-retorno', true));
                        }
                    }
                }
            });
        },
        onCancelLocationEditor() {
            this.$emit('onCancelLocationEditor');
        },
        /**
         * @70830 - essa função é executada a cada vez que é clicado no mapa.
         *
         * A variável validateAddress, contém todas as informações que são necessárias,
         * para um determinado endereço seja válido. Foi feito uma verificação de como o Google Maps
         * retorna o endereço.
         *
         * ['postal_code', 'administrative_area_level_1', 'administrative_area_level_2', 'route'],
         *
         * postal_colode -> Código Postal
         * administrative_area_level_1 -> Estado,
         * administrative_area_level_2 -> Cidade
         * route -> Rua, Avenida etc.
         */
        getLocationValid() {
            let validations = [];
            let resultAddress = [];

            this.$refs.gmap.codeAddress(
                `${this.center.lat}, ${this.center.lng}`,
                (result, status) => {
                    if (status == 'OK') {
                        resultAddress = result[0].address_components;

                        resultAddress.forEach((address) => {
                            address.types.forEach((type) => {
                                if (this.validateAddress.includes(type)) {
                                    validations.push(type);
                                }
                            });
                        });

                        if (
                            validations.length === this.validateAddress.length ||
                            validations.includes(
                                'administrative_area_level_1',
                                'administrative_area_level_2',
                                'route'
                            )
                        ) {
                            this.$emit('updateLocation', {
                                center: this.center,
                            });
                        } else {
                            if (!this.locationValid) {
                                this.msgs.push(
                                    new Message('alert', 'localizacao-selecionada-invalida', true)
                                );
                                return;
                            }
                        }
                    } else {
                        if (status == 'REQUEST_DENIED') {
                            this.msgs.push(
                                new Message(
                                    'error',
                                    this.$t('msg-geocode-activate'),
                                    true,
                                    false
                                )
                            );
                        }
                        this.msgs.push(
                            new Message(
                                'error',
                                this.$t('msg-geocode-fail') + status,
                                true,
                                false
                            )
                        );
                    }
                }
            );
        },
    },
};
</script>

<style lang="scss">
.buttons-maps {
    text-align: right;

    button {
        min-width: 100px;
        padding-left: 10px;
        padding-right: 10px;
        margin-bottom: 10px;

        &:not(:first-child) {
            margin-left: 10px !important;
        }
    }
}

.location {
    width: 100%;
    height: auto;
    flex: 1 1 auto;
    position: relative;
    min-height: 350px;
    height: auto;
    display: block;
    clear: both;
    border: solid 2px #f9f9f9;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}
</style>
